export type DevicesTestingType = 'zoom' | 'skype';

export interface Range {
    fromMs: number;
    toMs: number;
}

export interface DevicesTestingOptions {
    selectedDateRange: Range;
    login: string;
    password: string;
    skypeLogin?: string;
    zoomLink?: string;
    comment?: string;
    lang: string;
}

export interface DevicesTestingFormSettings {
    type: DevicesTestingType;
    selectedDateRange?: Range;
    login: string;
    password: string;
    skypeLogin?: string;
    comment: string;
    lang: string;
}

export enum TestingDateStatus {
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    AWAITING = 'AWAITING',
    PASSED = 'PASSED',
    NOT_SPECIFIED = 'NOT_SPECIFIED',
}

export type SerializedDevicesTestingRecord = {
    type: 'zoom' | 'skype';
    options: DevicesTestingOptions;
};

export type DevicesTestingStatusMeta =
    | {
          record: SerializedDevicesTestingRecord;
          status:
              | TestingDateStatus.APPROVED
              | TestingDateStatus.AWAITING
              | TestingDateStatus.REJECTED
              | TestingDateStatus.PASSED;
      }
    | {
          status: TestingDateStatus.NOT_SPECIFIED;
      };

export const initialDevicesTestingOptions: DevicesTestingFormSettings = {
    type: 'zoom',
    selectedDateRange: undefined,
    login: '',
    password: '',
    skypeLogin: '',
    comment: '',
    lang: 'ru',
};

export const parseDevicesTestingOptions = (record: SerializedDevicesTestingRecord): DevicesTestingFormSettings => {
    switch (record.type) {
        case 'skype':
            return {
                ...(record.options ?? initialDevicesTestingOptions),
                comment: record.options.comment ?? initialDevicesTestingOptions.comment,
                type: 'skype',
            };
        default:
            return {
                ...(record.options ?? initialDevicesTestingOptions),
                comment: record.options.comment ?? initialDevicesTestingOptions.comment,
                type: 'zoom',
            };
    }
};

export const serializeDevicesTestingOptions = (
    settings: DevicesTestingFormSettings,
): SerializedDevicesTestingRecord => {
    return {
        type: settings.type,
        options: {
            login: settings.login,
            password: settings.password,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            selectedDateRange: settings.selectedDateRange!,
            skypeLogin: settings.skypeLogin,
            comment: settings.comment || undefined,
            lang: settings.lang,
        },
    };
};
